import { IconMode } from "@components/general/Icon";
import TabPanel, { ITabPanelItems } from "@components/general/TabPanel"
import CheckinTabPanel from "@components/home/CheckinTabPanel";
import FlightSearchTabPanel from "@components/home/FlightSearchTabPanel";
import ManageBookingTabPanel from "@components/home/ManageBookingTabPanel";
import Translate from "@service/Translate";
import { FC } from "react"

export const ReservationTabPanel: FC = () => {
    const { tr } = Translate;
    const tabPanelItems: ITabPanelItems[] = [
        { title: tr("btn_ticket_reserve"), icon: "icon-airplane", content: <FlightSearchTabPanel /> },
        { title: tr("online_checkin"), icon: "icon-seat-upgrade", content: <CheckinTabPanel /> },
        { title: tr("my_trips"), icon: "icon-list1", content: <ManageBookingTabPanel /> }
    ];

    return (
        <div className="reservation-tab-panel">
            <TabPanel          
                dataSource={tabPanelItems}
                iconSetting={{ iconField: "icon", mode: IconMode.Font }}
            />
        </div>
    )
}